import type { ExperimentalQueries } from '../__types__/ExperimentalQueries';
import { fetchJSON } from '../fetchJSON';
import { MediaType } from '../MediaType';

export const experimentalContentDraftDiff: ExperimentalQueries['experimentalContentDraftDiff'] = (
	_,
	{ contentId },
	{ network },
) =>
	fetchJSON(network, `/wiki/rest/tinymce/1/content/${contentId}/draft/diff/json`, {
		method: 'GET',
		headers: {
			'Content-Type': MediaType.JSON,
		},
	}).catch(() => ({}));
